import { useRef, useEffect } from 'react';

function useDependentRef(callback, dependency) {
  /*
  A custom hook to create a ref whose current value is derived from a dependency and updates
  whenever the dependency changes.
  @param {Function} callback - A function that takes the dependency as an argument. This function
  will be called whenever the dependency changes, updating the ref with the return value.
  @param {Any} dependency - An single dependency that will be passed to the callback.
  @returns {Object} A ref object whose current value is the return value of the callback.
  */
  const ref = useRef();
  useEffect(() => {
    if (dependency) {
      ref.current = callback(dependency);
    }
  }, [dependency, callback]);
  return ref;
}

export default useDependentRef;
